/**
 * Props for {@link SupportTicketDescription}.
 */
interface SupportTicketDescriptionProps {
  description: string;
}

/**
 * Renders the ticket description or confidentiality notice block.
 *
 * @param props - Description body text.
 * @returns Description text without extra spacing wrappers.
 */
const SupportTicketDescription = ({
  description,
}: SupportTicketDescriptionProps) => {
  return (
    <div className="support-tickets-content-description text-tiny font-normal text-primaryGray-4">
      {description}
    </div>
  );
};

export default SupportTicketDescription;
